// extracted by mini-css-extract-plugin
module.exports = {"scollableNavBar":"CustomTabs_scollableNavBar__3Pxgt","tabContainer":"CustomTabs_tabContainer__A5grx"};